import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, single } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private languageSubject = new BehaviorSubject<string>('Tr');

  // Using WritableSignal for reactive titles
  TotalTitle = signal<string>('Total');
  MyOrderList = signal<string>('Me Order List');
  MenuPageTitle = signal<string>('Menu Page Title');
  OurBranches = signal<string>('OurBranches');
  CallBranch = signal<string>('CallBranch');
  GetDirection = signal<string>('CallBranch');
  OurOffers = signal<string>('Our Offers');
  OurApplication = signal<string>('Our Application');
  OurSocials = signal<string>('Our Socials');
  Description = signal<string>('Description');
  LearnMore = signal<string>('Learn More');
  Home = signal<string>('Home');
  Menu = signal<string>('Menu');
  Cart = signal<string>('Cart');
  SuccessOrder = signal<string>('Your Order Has been Sent Successfully');
  Thanks = signal<string>('Thank You for Choosing Hungry Birds');
  RatingReminder = signal<string>(
    "Your opinion matters to us! Don't forget to rate your order and help us improve your experience.",
  );
  RateUs = signal<string>('Rate Us');
  CannotRate = signal<string>(
    'Thank you for your time this order has been rated.',
  );
  YourOpinion = signal<string>('Your Opinion');
  StudentOrder = signal<string>(
    'To Get Student Price Please Enter Your Student Number',
  );
  TypeOfOrder = signal<string>('Type Of Order');
  DineIn = signal<string>('Dine In');
  TakeAway = signal<string>('Take Away');

  //cashier Interface
  NewOrderPageTitle = signal<string>('New Orders');
  OrderNumber = signal<string>('Order Number');
  TableNumber = signal<string>('Table Number');
  Total = signal<string>('Total');
  Time = signal<string>('Time');
  OrderDetails = signal<string>('Order Details');
  ViewOrderDetails = signal<string>('View Order Details');

  //Single Order Page
  ItemName = signal<string>('Item Name');
  ItemCount = signal<string>('Item Count');
  ItemNote = signal<string>('Item Note');
  price = signal<string>('Price');
  OrderSaved = signal<string>('Order Saved');
  PrintOrder = signal<string>('Print the Order');

  //Ordres History
  OrdersHistory = signal<string>('Orders History');
  Date = signal<string>('Date');

  //cashier navigation
  NewOrders = signal<string>('New Orders');
  TodaysOrder = signal<string>("Today's Orders");

  //sucess message
  YourOrderID = signal<string>('Your Order ID:  ');

  //notes overlay

  notesTitle = signal<string>('Enter your notes');
  notesPlaceholder = signal<string>('For Example: No Pickles, Cheddar Sauce');
  Save = signal<string>('Save');

  //scanner title
  scannerTitle = signal<string>('Please scan the Qr Code');
  scannerCloseButton = signal<string>('Close Scanner');

  //rating

  ratingMessage = signal<string>(
    'Thank you for rating! We are waiting for you again',
  );

  //footer
  footer1 = signal<string>('We would love to let you know');
  footer2 = signal<string>(
    'Prices are exclusive of VAT. A 10% VAT will be added to all listed prices.',
  );

  //Coupon
  HowToGet = signal<string>('How To Get ');
  Coupon = signal<string>('Coupon');
  Code = signal<string>('Code?');
  Condition1 = signal<string>('1. Leave us a review on Google Maps');
  Condition2 = signal<string>('2. Follow our Instagram profile');
  Condition3 = signal<string>(
    '3. Leave a comment on the pinned reels in our profile',
  );
  ApplyCoupon = signal<string>('Apply Coupon Code');

  validate = signal<string>('validate');

  categoryName = signal<string>('Category');

  currentLanguage$ = this.languageSubject.asObservable();

  setLanguage(language: string) {
    this.languageSubject.next(language);
    this.updateTitles(); // Update titles when language changes
  }

  getLanguage(): string {
    return this.languageSubject.value;
  }

  constructor() {
    this.updateTitles(); // Set titles based on the default language on initialization
  }

  private updateTitles() {
    switch (this.getLanguage()) {
      case 'Ar':
        this.TotalTitle.set('الإجمالي');
        this.MyOrderList.set('قائمة الطلب');
        this.MenuPageTitle.set('قائمة الطعام');
        this.OurBranches.set('أفرعنا');
        this.CallBranch.set('اتصل بنا');
        this.GetDirection.set('الموقع');
        this.OurOffers.set('عروضنا');
        this.OurApplication.set('تطبيقاتنا');
        this.OurSocials.set('السوشال ميديا');
        this.Description.set('الوصف');
        this.LearnMore.set('المزيد');
        this.Home.set('الرئيسة');
        this.Menu.set('المنيو');
        this.Cart.set('الطلب');
        this.SuccessOrder.set('لقد تم إرسال طلبكم بنجاح');
        this.Thanks.set('شكراً لاختياركم هانغري بيرد');
        this.RatingReminder.set(
          'رأيك مهم بالنسبة لنا! لا تنسى تقييم طلبك ومساعدتنا في تحسين تجربتك',
        );
        this.RateUs.set('قيم طلبك');
        this.CannotRate.set('شكرا لكم لقد تم تقييم طلبكم من قبل');
        this.YourOpinion.set('رأيكم يهمنا');
        this.StudentOrder.set(
          'للحصول على خصم الطالب الرجاء إدخال رقم الطالب الخاص بك',
        );
        this.TypeOfOrder.set('الرجاء تحديد مكان الطلب');
        this.DineIn.set('في المطعم');
        this.TakeAway.set('طلب خارجي');

        //cashier interface
        this.NewOrderPageTitle.set('الطلبات الجديدة');
        this.OrderNumber.set('رقم الطلب');
        this.TableNumber.set('رقم الطاولة');
        this.Total.set('الإجمالي');
        this.Time.set('الوقت');
        this.OrderDetails.set('تفاصيل الطلب');
        this.ViewOrderDetails.set('عرض تفاصيل الطلب');

        //single Order Page
        this.ItemName.set('اسم العنصر');
        this.ItemCount.set('عدد العناصر');
        this.ItemNote.set('ملاحظة العنصر');
        this.price.set('السعر');
        this.OrderSaved.set('تم حفظ الطلب');

        //Ordres History
        this.OrdersHistory.set('الطلبات السابقة');
        this.Date.set('التاريخ');
        this.NewOrders.set('الطلبات الجديدة');
        this.TodaysOrder.set('طلبات اليوم');
        this.PrintOrder.set('اطبع الطلب');

        //sucessmessage
        this.YourOrderID.set('رقم الطلبك');

        //notesOverlay
        this.notesTitle.set('اكتب ملاحظاتك');
        this.notesPlaceholder.set('على سبيل المثال: لا مخللات، صلصة شيدر');

        //scanner
        this.scannerTitle.set('الرجاء مسح كود المنيو أمامكم');
        this.scannerCloseButton.set('أغلق النافذة');

        //Save
        this.Save.set('حفظ');

        //rating
        this.ratingMessage.set(
          'شكرا لكم على التقييم! نحن في انتظاركم مرة أخرى',
        );
        this.validate.set('التحقق');
        this.categoryName.set('فئة');

        //footer
        this.footer1.set('نود إعلامكم أنه');
        this.footer2.set('.الأسعار شاملة لضريبة القيمة المضافة');

        //Coupon
        this.HowToGet.set(' كيفية الحصول على');
        this.Coupon.set('كود خصم ');
        this.Code.set('؟');
        this.Condition1.set('اترك لنا تقييما على خرائط جوجل');
        this.Condition2.set('تابع حسابنا على انستغرام');
        this.Condition3.set(
          'اترك لنا تعليقا على فيديو الفطور المثبت في الصفحة',
        );
        this.ApplyCoupon.set('احصل على كود خصم');
        break;

      case 'En':
        this.TotalTitle.set('Total');
        this.MyOrderList.set('My Order List');
        this.MenuPageTitle.set('Our Menu');
        this.OurBranches.set('Our Branches');
        this.CallBranch.set('Call Branch');
        this.GetDirection.set('Get Direction');
        this.OurOffers.set('Our Offers');
        this.OurApplication.set('Our Application');
        this.OurSocials.set('Our Social Media');
        this.Description.set('Description');
        this.LearnMore.set('Learn More');
        this.Home.set('Home');
        this.Menu.set('Menu');
        this.Cart.set('Cart');
        this.SuccessOrder.set('Your Order Has been Sent Successfully');
        this.Thanks.set('Thank You for Choosing Hungry Birds');
        this.RatingReminder.set(
          "Your opinion matters to us! Don't forget to rate your order and help us improve your experience.",
        );
        this.RateUs.set('Rate Us');
        this.CannotRate.set(
          'Thank you for your time this order has been rated.',
        );
        this.YourOpinion.set('Your Opinion');
        this.StudentOrder.set(
          'To Get Student Price Please Enter Your Student Number',
        );
        this.TypeOfOrder.set('Type Of Order');
        this.DineIn.set('Dine In');
        this.TakeAway.set('Take Away');
        //cashier interface
        this.NewOrderPageTitle.set('New Orders');
        this.OrderNumber.set('Order Number');
        this.TableNumber.set('Table Number');
        this.Total.set('Total');
        this.Time.set('Time');
        this.OrderDetails.set('Order Details');
        this.ViewOrderDetails.set('View Order Details');

        //single Order Page
        this.ItemName.set('Item Name');
        this.ItemCount.set('Item Count');
        this.ItemNote.set('Item Note');
        this.price.set('Price');
        this.OrderSaved.set('Order Saved');
        this.PrintOrder.set('Print the Order');

        //Ordres History
        this.OrdersHistory.set('Orders History');
        this.Date.set('Date');

        //Ordres History
        this.OrdersHistory.set('Orders History');
        this.Date.set('Date');

        this.NewOrders.set('New Orders');
        this.TodaysOrder.set("Today's Orders");

        this.YourOrderID.set('Your Order Number');

        //notesOverlay
        this.notesTitle.set('Enter your notes');
        this.notesPlaceholder.set('For Example: No Pickles, Cheddar Sauce');

        //scanner
        this.scannerTitle.set('Please scan the Menu QR code');
        this.scannerCloseButton.set('Close Scanner');

        //rating
        this.ratingMessage.set(
          'Thank you for rating! We are waiting for you again',
        );

        //Save
        this.Save.set('Save');

        this.validate.set('validate');

        this.categoryName.set('Category');

        //footer
        this.footer1.set('We would love to let you know');
        this.footer2.set('Tax is already included');

        //Coupon
        this.HowToGet.set('How To Get ');
        this.Coupon.set('Coupon');
        this.Code.set('Code?');
        this.ApplyCoupon.set('Apply Coupon Code');
        this.Condition1.set('1. Leave us a review on Google Maps');
        this.Condition2.set('2. Follow our Instagram profile');
        this.Condition3.set(
          '3. Leave a comment on the pinned reels in our profile',
        );

        break;

      default:
        this.TotalTitle.set('Toplam');
        this.MyOrderList.set('Sipariş Listesi');
        this.MenuPageTitle.set('Menü');
        this.OurBranches.set('Şübelerimiz');
        this.CallBranch.set('Bizi Arayın');
        this.GetDirection.set('Yol Tarifi');
        this.OurOffers.set('Kampanyalarımız');
        this.OurApplication.set('Uygulamamız');
        this.OurSocials.set('Sosyal Medyamız');
        this.Description.set('Açıklama');
        this.LearnMore.set('Daha Fazla');
        this.Home.set('Ana Sayfa');
        this.Menu.set('Menü');
        this.Cart.set('Sepet');
        this.SuccessOrder.set('Siparişiniz alındı');
        this.Thanks.set('Hungry Birds Tercih Ettiğiniz İçin Teşekkür Ederiz');
        this.OrderSaved.set('Siparişi Kaydet');
        this.RatingReminder.set(
          'Fikriniz bizim için önemli! Siparişinizi değerlendirmeyi unutmayın ve deneyiminizi iyileştirmemize yardımcı olun.',
        );
        this.RateUs.set('Siparişini Değerlendir');
        this.CannotRate.set(
          'Değerlendirmeniz için Teşekkür Ederiz Bu sipariş daha önceden değerlendirilmiştir.',
        );
        this.YourOpinion.set('Puanınız');
        this.StudentOrder.set(
          'Öğrenci indirim almak için lütfen öğrenci numaranızı giriniz',
        );
        this.TypeOfOrder.set('Sipariş Türü');
        this.TakeAway.set('Paket');
        this.DineIn.set('Restauranda');

        //cashier Interface
        this.NewOrderPageTitle.set('Yeni Siparişler');
        this.OrderNumber.set('Sipariş Numarası');
        this.TableNumber.set('Masa Numarası');
        this.Total.set('Toplam');
        this.Time.set('Saat');
        this.OrderDetails.set('Sipariş Detayları');
        this.ViewOrderDetails.set('Sipariş Detayları');

        //single Order Page
        this.ItemName.set('Ürün Adı');
        this.ItemCount.set('Ürün Adedi');
        this.ItemNote.set('Ürün Notu');
        this.price.set('Fiyat');

        //Todays Orders
        this.TodaysOrder.set('Bügünün Siparişlers');

        //Ordres History
        this.OrdersHistory.set('Sipariç Geçmişi');
        this.Date.set('Tarih');

        this.OrderSaved.set('Sipariş Kaydet');
        this.PrintOrder.set('Siparişi Yazdır');

        this.NewOrders.set('Yeni Siparişler');

        this.YourOrderID.set('sipariş numaranız');

        //notesOverlay
        this.notesTitle.set('Not Ekle');
        this.notesPlaceholder.set('Örnek: Turşusuz, Cheddar Sosu');

        //scanner
        this.scannerTitle.set('Lütfen Menu QR kodunu tarayın');
        this.scannerCloseButton.set('tarayıcıyı kapat');

        //Save
        this.Save.set('kaydet');
        //rating
        this.ratingMessage.set(
          'Puanladığınız için teşekkür ederiz! Sizi tekrar görmek için sabırsızlanıyoruz.',
        );

        this.validate.set('kontrol et');

        this.categoryName.set('kategori');

        //footer
        this.footer1.set('Sizi bilgilendirmek istiyoruz');
        this.footer2.set('Fiyatlara KDV dahildir.');

        //Koupon
        this.HowToGet.set('Nasıl Alınır?');
        this.Coupon.set('İndirim');
        this.Code.set('Kodu');
        this.ApplyCoupon.set('İndirim Kodu Uygula');
        this.Condition1.set("1. Google Haritalar'da bize bir yorum bırakın");
        this.Condition2.set('2. Instagram profilimizi takip edin');
        this.Condition3.set(
          "3. Profilimizdeki sabitlenmiş reels'e bir yorum bırakın",
        );
        break;
    }
  }
}
